import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import "./locales";
import SimpleNotifyPortal from "components/custom/SimpleNotify";
import SimpleNotifyTest from "components/custom/SimpleNotifyTest";

// Set to true to show test buttons, false for production
const SHOW_TEST_UI = false;

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter history={history}>
          <Theme>
            <Layout />
            {/* Add the notification test UI if enabled */}
            {SHOW_TEST_UI && (
              <div className="fixed z-50 bottom-4 right-4">
                <SimpleNotifyTest />
              </div>
            )}
            {/* Add the notification portal */}
            <SimpleNotifyPortal />
          </Theme>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
